import COLORS from 'constants/colors';

export const AV_REVIEW_CONFIG = 'av_review_config_v2';

export const AV_REVIEW_ROLES = {
  ADMIN: 'admin',
  REVIEWER: 'reviewer',
};

export const REVIEW_STATUS = {
  ASSIGNED: 'ASSIGNED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUBMITTED: 'SUBMITTED',
};

export const DETECTION_TYPES = {
  AWAY: 'away',
  SLEEP: 'sleep',
  DARK_LIGHTING: 'dark_lighting',
  POOR_CAMERA_ANGLE: 'poor_camera_angle',
  PEOPLE_IN_BACKGROUND: 'people_in_background',
};

export const DETECTION_TYPES_CONFIG = {
  [DETECTION_TYPES.AWAY]: {
    id: DETECTION_TYPES.AWAY,
    label: 'Away',
    color: COLORS.ORANGE_6,
    bgColor: COLORS.ORANGE_1,
    indicatorColor: COLORS.ORANGE_4,
    invalidReasons: [],
  },
  [DETECTION_TYPES.SLEEP]: {
    id: DETECTION_TYPES.SLEEP,
    label: 'Sleep',
    color: COLORS.RED_6,
    bgColor: COLORS.RED_1,
    indicatorColor: COLORS.RED_4,
    invalidReasons: [
      { value: 'not_sleeping', label: 'Not sleeping' },
      { value: 'looking_down', label: 'Looking down' },
      { value: 'using_phone', label: 'Using phone' },
      { value: 'distracted', label: 'Distracted' },
      { value: 'workspace_setup', label: 'Improper Workspace' },
      { value: 'attire', label: 'Improper attire' },
    ],
  },
  [DETECTION_TYPES.DARK_LIGHTING]: {
    id: DETECTION_TYPES.DARK_LIGHTING,
    label: 'Dark lighting',
    color: COLORS.YELLOW_6,
    bgColor: COLORS.YELLOW_1,
    indicatorColor: COLORS.YELLOW_4,
    invalidReasons: [],
  },
  [DETECTION_TYPES.POOR_CAMERA_ANGLE]: {
    id: DETECTION_TYPES.POOR_CAMERA_ANGLE,
    label: 'Poor camera angle',
    color: COLORS.YELLOW_6,
    bgColor: COLORS.YELLOW_1,
    indicatorColor: COLORS.YELLOW_4,
    invalidReasons: [],
  },
  [DETECTION_TYPES.PEOPLE_IN_BACKGROUND]: {
    id: DETECTION_TYPES.PEOPLE_IN_BACKGROUND,
    label: 'People in background',
    color: COLORS.YELLOW_6,
    bgColor: COLORS.YELLOW_1,
    indicatorColor: COLORS.YELLOW_4,
    invalidReasons: [],
  },
};

export const REVIEW_STATUS_CONFIG = {
  [REVIEW_STATUS.ASSIGNED]: {
    label: 'Assigned',
    color: COLORS.GREY_5,
    bgColor: COLORS.GREY_2,
  },
  [REVIEW_STATUS.IN_PROGRESS]: {
    label: 'In Progress',
    color: COLORS.BLUE_5,
    bgColor: COLORS.BLUE_1,
  },
  [REVIEW_STATUS.SUBMITTED]: {
    label: 'Submitted',
    color: COLORS.GREEN_5,
    bgColor: COLORS.GREEN_1,
  },
};
